<template>
  <b-card class="w-100">
    <div class="d-flex justify-content-center align-items-center h-100 my-5">
      <div class="fadeInUp">
        <div class="d-flex justify-content-center align-items-center">
          <span class="mr-1"
            ><img
              style="width: 12rem"
              src="https://storage.googleapis.com/marketcenter-labels-local/logo_enviame.svg"
              alt="Logo Enviame"
          /></span>
          <span class="line"></span>
          <span class="ml-1"
            ><img
              style="width: 12rem"
              src="https://storage.googleapis.com/marketcenter-labels/multivende-logo.png"
              alt="Logo Multivende"
          /></span>
        </div>
        <div v-if="loading.auth" class="mt-5 text-center">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;"/>
        </div>
        <div v-else class="mt-5 mb-4">
          <div v-if="success">
            <div class="text-center">
              <span class="text-success"
                ><i class="fa fa-check-circle fa-5x" aria-hidden="true"></i
              ></span>
            </div>
            <div class="text-center mt-1">
              <p class="title">¡La autenticación ha sido realizada con éxito!</p>
            </div>
            <div class="text-center mt-2">
              <b-button
                variant="warning"
                @click="redirect"
              >
                Ir al inicio
              </b-button>
            </div>
          </div>
          <div v-else>
            <div class="text-center">
              <span class="text-warning"
                ><i
                  class="fa fa-exclamation-triangle fa-5x"
                  aria-hidden="true"
                ></i
              ></span>
            </div>
            <div class="text-center mt-1">
              <p class="title text-wrap">
                ¡La autenticación <strong>no</strong> ha sido realizada con éxito!
              </p>
            </div>
            <div class="mt-2">
              <div v-if="errorType === 'warehouse_not_found'" class="text-center">
                Para integrarte con Envíame, necesitas tener una bodega. Haz clic en
                el siguiente enlace para crearla. Una vez creada, podrás instalar la
                aplicación nuevamente e iniciar el proceso de autenticación.
                <div class="text-center mt-1">
                  <a :href="redirectCompany">CREAR NUEVA BODEGA &#128073;</a>
                </div>
              </div>
              <div v-else-if="errorType === 'code_expired'" class="text-center">
                El código de acceso ha expirado. Inicia el proceso nuevamente para
                completar la autenticación.
              </div>
              <div
                v-else-if="errorType === 'user_not_ecommerce'"
                class="text-center"
              >
                La integración no es compatible con tu empresa. Para más
                información, contacta a nuestro equipo de Support enviando un correo
                a <strong>support@enviame.io</strong>.
              </div>
              <div v-else class="text-center">
                Inicia el proceso nuevamente para completar la autenticación.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      errorType: null,
      success: null,
      loading: {
        auth: false
      }
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      iniUser: 'getIniUser',
      generalLoading: 'getLoading'
    }),
    redirectCompany() {
      const company_id = this.mySession?.shipper?.id ?? this.mySession?.organization?.id
      return `/companies/${company_id}`
    }
  },
  watch: {
    generalLoading: {
      handler () {
        this.loading.auth = !!this.generalLoading.postAuthMultivende
      },
      deep: true
    }
  },
  mounted() {
    this.fetchAuthMultivende()
  },
  methods: {
    fetchAuthMultivende() {
      const url = new URL(window.location.href)
      const data = {
        name: 'postAuthMultivende',
        params: { code: url.searchParams.get('code') },
        onSuccess: (res) => {
          this.success = res?.success ?? res?.data?.success
          this.errorType = res?.message
          if (this.success) sessionStorage.removeItem('redirect_url')
        },
        onError: (err) => {
          this.success = err?.success
          this.errorType = err?.message
        }
      }
      this.$store.dispatch('fetchService', data)
    },
    redirect() {
      const currentRoute = this.$router.currentRoute
      if (currentRoute) {
        const homeRoute = getHomeRouteForLoggedInUser(this.mySession.role, currentRoute, this.iniUser)
        if (homeRoute) {
          this.$router.replace(homeRoute)
        }
      }
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 18px
}
.line {
  border-left: 2px solid #091e3f;
  height: 40px;
}
</style>
